export interface TransporteurEntite {
    camion: string;
    remorque: string;
    chauffeur: string;
    nbItems?: number;
    /** Clé unique pour la sélection PrimeNG (camion|remorque|chauffeur). */
    cle?: string;
}

export function obtenirCleTransporteur(
    transporteur: Pick<TransporteurEntite, 'camion' | 'remorque' | 'chauffeur'>
): string {
    return `${transporteur.camion}|${transporteur.remorque}|${transporteur.chauffeur}`;
}

export function assignerClesTransporteurs(transporteurs: TransporteurEntite[]): TransporteurEntite[] {
    return transporteurs.map(transporteur => ({
        ...transporteur,
        cle: obtenirCleTransporteur(transporteur)
    }));
}